export const globalLoaderSelector = state => state.shared.loading;
export const messageSelector = state => state.shared.message;
export const errorMessageSelector = state => state.error.apiCall;
export const errorSessionSelector = state => state.error.session;
